import Vue from 'vue'
import App from './App.vue'
// 引入路由
import router from './router'
import store from './store'
import './plugins/element.js'
import './plugins/element.css'
// 格式化金钱全局函数
import money from './assets/changeNumMoneyToChinese'
Vue.use(money)
// 打印
import Print from 'vue-print-nb'
Vue.use(Print); //注册


Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
